<template>
  <div>
    <div class="modal fade" ref="myModal">
      <div class="modal-dialog modal-dialog-scrollable" v-bind:class="[modalSize]">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header" v-show="showFooter">
            <slot name="header"></slot>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer" v-show="showFooter">
            <slot name="footer"></slot>
            <button type="button" class="btn btn-sm btn-default" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">Close</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery';
  import Vue, { onMounted, ref } from 'vue';
  require('../../../node_modules/bootstrap/dist/js/bootstrap.js');

  export default {
    setup(props, { emit }) {
      const modalSize = ref('modal-md')

      const myModal = ref({})
      const showFooter = ref(true)

      let state = 'hide'
      let process = false
      let resover = null
      let loader = null

      const closeModal = () => {
        if (state === 'hide' || process) { return }

        return new Promise((rs) => {
          console.log('hide modal')
          process = true
          loader.modal('hide')
          resover = rs;
        })
      }

      const openModal = () => {
        if (state === 'show' || process) { return }
        return new Promise((rs) => {
          console.log('show modal')
          process = true
          //loader.modal('show')
          loader.modal({
            backdrop: 'static',
            keyboard: true,
            show: true
          });
          resover = rs;
        })
      }

      const setSize = (t) => {
        modalSize.value = t;
      }

      const setFooter = (t) => {
        showFooter.value = t;
      }

      const sleep = function (ms) {
        return new Promise(rs => {
          setTimeout(rs, ms)
        });
      }

      onMounted(async () => {
        await sleep(200);
        loader = $(myModal.value);

        loader.on("hidden.bs.modal", () => {
          resover();
          process = false;
          state = 'hide'
        });

        loader.on("shown.bs.modal", () => {
          resover();
          process = false;
          state = 'show'
        });

        emit('modal-ready', null);
      })

      return {
        modalSize,
        myModal,
        closeModal,
        openModal,
        setSize,
        setFooter,
        showFooter
      }
    }
  }
</script>
